import invariant from 'tiny-invariant';

export default function applicationRuntimeHostname(location: Location | URL): string {
  invariant(location != null, 'Location or URL to extract runtime hostname is undefined or null.');
  const portPart = ['80', '443'].includes(location.port) ? '' : `:${location.port}`;
  return `${location.protocol}//${location.hostname}${portPart}`;
}
